import { Pipe, PipeTransform } from '@angular/core';
import { FilterValue } from '../classes/filter-value';
import { FilterValueType } from '../enums/filter-value-type';
import { DateService } from '../services/date.service';

@Pipe({
  name: 'burialsSearchFilter'
})
export class BurialsSearchFilterPipe implements PipeTransform {

  constructor(private dateService: DateService) { }

  transform(burials: any[], filters: FilterValue[]): any[] {
    if (!burials || !filters || filters.length === 0) { 
      return burials; 
    }

    return burials.filter(burial => {
      // Zähle, wie viele Filter für dieses Burial passen
      let matchingFilters = 0;

      for (const filter of filters) {
        if (!filter || !filter.value) continue;

        switch (filter.type) {
          case FilterValueType.status:
            // Status-Filterung
            if (burial && burial.htmlHeaderClass) {
              // Direkte Übereinstimmung mit htmlHeaderClass
              if (filter.value === burial.htmlHeaderClass) {
                matchingFilters++;
                continue;
              }
              
              // Alternativ: Status-Map für numerische Werte
              const statusMap: { [key: string]: string } = {
                '0': 'unconfirmed',
                '1': 'on-hold',
                '2': 'confirmed',
                '3': 'isWhite'
              };
              
              if (statusMap[filter.value] === burial.htmlHeaderClass) {
                matchingFilters++;
              }
            }
            break;

          case FilterValueType.entryDate:
            // Eingangsdatum-Filterung
            if (burial) {
              // Prüfe verschiedene mögliche Datumsfelder
              const dateFields = [
                burial.created_at,
                burial.auftrag_erstellt,
                burial.entryDate
              ];
              
              for (const dateField of dateFields) {
                if (dateField) {
                  const burialDate = this.dateService.onlyDateFromDateTimeString(dateField);
                  if (burialDate === filter.value) {
                    matchingFilters++;
                    break;
                  }
                }
              }
            }
            break;

          case FilterValueType.burialDate:
            // Beerdigungsdatum-Filterung
            if (burial) {
              // Prüfe verschiedene mögliche Datumsfelder
              const dateFields = [
                burial.burial_date,
                burial.burialdate,
                burial.cremationDate
              ];
              
              for (const dateField of dateFields) {
                if (dateField) {
                  const burialDate = this.dateService.onlyDateFromDateTimeString(dateField);
                  if (burialDate === filter.value) {
                    matchingFilters++;
                    break;
                  }
                }
              }
            }
            break;
        }
      }

      // Nur zurückgeben, wenn alle Filter übereinstimmen
      return matchingFilters === filters.length;
    });
  }
}
